<template>
  <div class="service-box">
    <div class="section-title">
      <img class="" src="../assets/images/service-title.png" alt="" />
    </div>
    <div class="service-main">
      <div class="map">
        <!-- <img src="../assets/images/map.png" alt="" srcset="" /> -->
        <examples style="width:800px;height:600px;"/>
      </div>
      <div class="data">
        <div
          class="service-list"
          :class="'service-list' + index"
          v-for="(item, index) in servicelist"
          :key="index"
        >
          <img :src="item.imgUrl" alt="" />
          <div>
            <div>
              <countTo
                ref="example"
                :class="'example' + index"
                class="num"
                :startVal="startVal"
                :endVal="item.num"
                :duration="3600"
              ></countTo
              ><span class="hotext">{{ item.hotext }}</span>
            </div>

            <h3 class="title">{{ item.title }}</h3>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import echarts from 'echarts'
import countTo from "vue-count-to";
import Examples from './example.vue'
import '../../node_modules/echarts/map/js/china.js'
export default {
  components: {
    countTo,
    echarts,
    Examples
  },
  data() {
    return {
      startVal: 0,
      servicelist: [
        {
          title: "运营平台",
          num: 221,
          imgUrl: require("../assets/images/data-icon1.png"),
          hotext: "个+",
        },
        {
          title: "全国合作渠道",
          num: 2200,
          imgUrl: require("../assets/images/data-icon2.png"),
          hotext: "家+",
        },
        {
          title: "服务学员",
          num: 80013600,
          imgUrl: require("../assets/images/data-icon3.png"),
          hotext: "人+",
        },
        {
          title: "研发课程",
          num: 50000,
          imgUrl: require("../assets/images/data-icon4.png"),
          hotext: "学时+",
        },
      ],
    };
  },
  methods: {
    start() {
      this.$nextTick(() => {
        let example = this.$refs.example;
        for (let i = 0; i < example.length; i++) {
         // console.log(example[i]);
          example[i].start();
        }
      });
    },
    
  },
  mounted () {
}
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/serviceView.vue